<template>
  <!-- Method to Use -->
  <!-- HTML: v-b-modal.molecule-modal-dialog--modal -->
  <!-- JS: this.$bvModal.show(modalId) -->

  <atom-modal
    :modalId="modalId"
    :isCloseOnBackDrop="isCloseOnBackDrop"
    :isShowXIcon="isShowXIcon"
    @onClickCloseIcon="onClickCloseIcon"
  >
    <template #header>
      <feather-icon
        v-if="icon"
        :class="['molecule-modal-dialog_icon', textColor]"
        :icon="icon"
      />
    </template>
    <template #body>
      <span
        v-if="textTitle"
        class="molecule-modal-dialog_text-title"
        :class="{
          'text-center': isTextCenter,
          'margin-bottom-26px': !textSubtitle && !isSlotBody,
        }"
        >{{ textTitle }}</span
      >
      <span
        v-if="textSubtitle"
        class="molecule-modal-dialog_text-subtitle"
        :class="{
          'text-center': isTextCenter,
          'margin-bottom-26px': !isSlotBody,
        }"
        >{{ textSubtitle }}</span
      >

      <div v-if="isSlotBody" class="molecule-modal-dialog_slot">
        <slot name="body"></slot>
      </div>
    </template>
    <template #footer>
      <div
        class="d-flex justify-content-between align-items-end w-100 flex-wrap"
        :class="classButton"
      >
        <div v-if="isButtonDelete" class="d-flex justify-content-start">
          <atom-button
            v-if="isButtonDelete && !isShowInputDelete"
            :isOnlyIcon="true"
            buttonId="button__delete"
            buttonStyle="flat"
            buttonColor="danger"
            iconLeft="Trash2Icon"
            styleInButton="background: rgba(234, 84, 85, 0.12); width: 50px;"
            :isDisable="isDisableButtonDelete"
            @click="isShowInputDelete = true"
          >
          </atom-button>
          <div v-if="isButtonDelete && isShowInputDelete" class="mr-1">
            <label class="text-danger"
              >Please type <b>{{ wordingToDelete }}</b> to confirm</label
            >
            <atom-input
              v-model="inputConfirmDelete"
              :placeholder="wordingToDelete"
            ></atom-input>
          </div>
        </div>
        <div
          :class="[
            isButtonDelete || isButtonAlignRight
              ? 'd-flex justify-content-end'
              : 'molecule-modal-dialog_button',
          ]"
          class="w-100"
        >
          <atom-button
            v-if="isButtonDelete && isShowInputDelete"
            buttonId="button__confirm-delete"
            buttonColor="danger"
            :isDisable="isDisableButtonConfirmDelete"
            @click="clickButtonDelete"
          >
            Delete
          </atom-button>

          <atom-button
            v-if="isButtonLeft && !isShowInputDelete"
            :buttonId="buttonIdLeft"
            :buttonStyle="buttonStyleLeft"
            :buttonColor="buttonColorLeft"
            :styleInButton="styleLeft"
            :isDisable="isDisableButtonLeft"
            @click="ClickButtonLeft"
          >
            <template>{{ buttonTextLeft }}</template>
          </atom-button>

          <div v-if="isButtonLeft && isButtonRight" class="button__space"></div>
          <atom-button
            v-if="isButtonRight"
            :buttonId="buttonIdRight"
            :buttonStyle="buttonStyleRight"
            :buttonColor="buttonColorRight"
            :styleInButton="styleRight"
            :isDisable="isDisableButtonRight"
            @click="onClickButtonRight"
          >
            <template>{{ buttonTextRight }}</template>
          </atom-button>
        </div>
      </div>
    </template>
  </atom-modal>
</template>

<script>
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomModal from "@/components/atoms/AtomModal.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
export default {
  name: "MoleculeModalDialog",
  components: { AtomModal, AtomButton, AtomInput },
  props: {
    modalId: {
      type: String,
      required: true,
    },
    //icon
    icon: {
      type: String,
      required: false,
      default: "",
    },
    iconColor: {
      type: String,
      required: false,
      default: "warning",
    },
    //text
    isTextCenter: {
      type: Boolean,
      required: false,
      default: false,
    },
    textTitle: {
      type: String,
      required: false,
      default: "",
    },
    textSubtitle: {
      type: String,
      required: false,
      default: "",
    },
    // slot body
    isSlotBody: {
      type: Boolean,
      required: false,
      default: false,
    },
    //button left side
    isButtonLeft: {
      type: Boolean,
      required: false,
      default: true,
    },
    buttonTextLeft: {
      type: String,
      required: false,
      default: "Yes",
    },
    buttonStyleLeft: {
      type: String,
      required: false,
      default: "filled",
    },
    buttonColorLeft: {
      type: String,
      required: false,
      default: "primary",
    },
    isDisableButtonLeft: {
      type: Boolean,
      required: false,
      default: false,
    },
    styleLeft: {
      type: String,
      required: false,
      default: null,
    },
    //button right side
    isButtonRight: {
      type: Boolean,
      required: false,
      default: true,
    },
    buttonTextRight: {
      type: String,
      required: false,
      default: "Cancel",
    },
    buttonStyleRight: {
      type: String,
      required: false,
      default: "border",
    },
    buttonColorRight: {
      type: String,
      required: false,
      default: "secondary",
    },
    isDisableButtonRight: {
      type: Boolean,
      required: false,
      default: false,
    },
    styleRight: {
      type: String,
      required: false,
      default: null,
    },
    isCloseOnBackDrop: {
      type: Boolean,
      required: false,
      default: true,
    },
    isShowXIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
    isCloseModal: {
      type: Boolean,
      required: false,
      default: true,
    },
    isButtonDelete: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDisableButtonDelete: {
      type: Boolean,
      required: false,
      default: false,
    },
    wordingToDelete: {
      type: String,
      required: false,
      default: "delete",
    },
    classButton: {
      type: String,
      required: false,
    },
    isButtonAlignRight: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: [
    "clickButtonLeft",
    "clickButtonRight",
    "clickIconClose",
    "clickButtonDelete",
  ],
  data() {
    return {
      buttonIdLeft: "molecule-modal-dialog_button__left",
      buttonIdRight: "molecule-modal-dialog_button__right",

      isShowInputDelete: false,
      inputConfirmDelete: null,
    }
  },
  computed: {
    textColor() {
      return "text-" + this.iconColor
    },

    isDisableButtonConfirmDelete() {
      return this.inputConfirmDelete !== this.wordingToDelete
    },
  },
  methods: {
    ClickButtonLeft() {
      this.$emit("clickButtonLeft", this.buttonIdLeft)
    },
    onClickButtonRight() {
      this.$emit("clickButtonRight", this.buttonIdRight)

      if (this.isCloseModal) this.$bvModal.hide(this.modalId)

      if (this.isButtonDelete) {
        this.isShowInputDelete = false
        this.inputConfirmDelete = null
      }
    },
    onClickCloseIcon() {
      this.$emit("clickIconClose")
    },
    clickButtonDelete() {
      this.$emit("clickButtonDelete")

      this.isShowInputDelete = false
      this.inputConfirmDelete = null
    },
  },
}
</script>

<style lang="scss" scoped>
.molecule-modal-dialog_icon {
  width: 80px;
  height: 80px;
  margin-top: 16px;
  margin-bottom: 18px;
}
.molecule-modal-dialog_text-title {
  display: block;
  margin-bottom: 6px;
  font-size: 21px;
  font-weight: 500;
  color: #5e5873;
  white-space: pre-line;

  overflow-wrap: break-word;
  word-break: break-word;
}
.molecule-modal-dialog_text-subtitle {
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #6e6b7b;
  white-space: pre-line;

  overflow-wrap: break-word;
  word-break: break-word;
}

.molecule-modal-dialog_slot {
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.molecule-modal-dialog_button {
  display: flex;
  margin-bottom: 25px;
  flex-wrap: wrap;
  justify-content: center;
}
.button__space {
  width: 15px;
}
.text-center {
  text-align: center;
}
.margin-bottom-26px {
  margin-bottom: 26px;
}
</style>
